import styled from "styled-components";

export const Container = styled.div`
`;
export const DaysWeekContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 10px;
    width: 300px;
`;

interface DayButtonProps {
    isSelectedStart: boolean;
    isSelectedEnd: boolean;
    isBetween: boolean;
    isPrevOrNext: boolean;
    daysStartedOnWeekend: boolean;
}

export const DayButton = styled.button<DayButtonProps>`
    background-color: ${({isSelectedStart,isSelectedEnd,isBetween,isPrevOrNext,daysStartedOnWeekend}) => isPrevOrNext ? 'gray' : isSelectedStart || isSelectedEnd ? 'aquamarine' : isBetween ? 'pink' :
        daysStartedOnWeekend ? '#a1a1a1' : isPrevOrNext ? 'gray' : '#dadada' } ;
    display: flex;
    justify-content: center;
    border: none;
    border-radius: 8px;
    padding: 4px;
                `;

export const CalendarContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    justify-content: center;
`;

export const CalendarContent = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    align-items: center;
    justify-content: center;
`;